<div class="flex flex-column gap-8">
	<mat-label>{{ 'mes.administration.terminal.terminal' | translate }}</mat-label>
	<mat-select [value]="currentTerminalId" (selectionChange)="terminalSelectionChange($event)" placeholder="{{ 'mes.administration.terminal.shared.active-terminal' | translate }}">
		@for (terminal of terminals; track terminal) {
			<mat-option [value]="terminal.id">({{ terminal.alias }}) {{ terminal.name }}</mat-option>
		}
	</mat-select>
</div>
